import { createGlobalRoute } from '@townsquare/router/create-route';

export const rovoRoute = createGlobalRoute({
	exact: true,
	name: 'rovo',
	path: '/rovo',
	layout: 'home',
	nav4Layout: 'expanded',
});
